import { render } from "./SampleSeller.vue?vue&type=template&id=52100210&scoped=true"
import script from "./SampleSeller.vue?vue&type=script&lang=js"
export * from "./SampleSeller.vue?vue&type=script&lang=js"

import "@/assets/css/components/Mypage/mypage_matching.css?vue&type=style&index=0&id=52100210&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52100210"]])

export default __exports__